const CNPJ = 'cnpj'
const CPF = 'cpf'
const DATE = 'date'
const EMAIL = 'email'
const NUMBER = 'number'
const PHONE = 'phone'
const SELECT = 'select'
const TEXT = 'text'

const FieldType = {
    CNPJ,
    CPF,
    DATE,
    EMAIL,
    NUMBER,
    PHONE,
    SELECT,
    TEXT,
}

export { FieldType }
